import React, { useEffect, useState } from 'react';
import '../../css/UserOverviewComponent.css';
import { getCurrentUser, getAppUser, getCookie } from '../../functions/utils.js'; // 
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEllipsisV, faSortDown, faSortUp, faFilter, faArrowCircleLeft} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faEllipsisV, faSortDown, faSortUp, faFilter, faArrowCircleLeft);

function UserOverviewComponent() {  
  const [listArray, setListArray] = useState([]);
  const [currentSort, setCurrentSort] = useState({type: false, sort: false});

  useEffect(() =>{
    init();
  }, []); 
  
  useEffect(() =>{
    handleSort();
  }, [currentSort]); 

  useEffect(()=>{

  }, [listArray]);
  
  async function init(){
    var currentUser = await getCurrentUser();
    if(currentUser){
      if(currentUser == 819){

        var appUsers = await getAppUsers();
        createListArray(appUsers);
      }
      else{
        window.location.href = '/app'
      }
    }
    else{
      return await init();
    }
  }

  async function getAppUsers(){
    const response = await fetch('/app_user/findAll');
    var responseData = await response.json();
    return responseData;
  }

  async function getUserInfo(ids){
    try{
      const response = await fetch('https://api2.factview.nl/user/findAllIn', {
        method: 'Post',
        headers: {
          'authorization': 'Bearer '+ getCookie("factview_access"),
          'Content-Type': 'application/json',
          'Accept': 'application/json' 
        },
        body: JSON.stringify(ids),
      });
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
          console.log(responseData);
          return responseData;
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function createListArray(appUserArray){
    var array = [];
    var ids = [];
    ids = appUserArray.map(u => u.user_id);
    var userInfo = await getUserInfo(ids);

    if(appUserArray.length > 0){
      for(var appUser of appUserArray){
        var object = false;
        var info = userInfo.find(u => u.id === appUser.user_id);
        var lastLogin = new Date(appUser.access_token_expires);
        lastLogin.setDate(lastLogin.getDate() - 1);
        
        var lastAction = new Date(appUser.last_action);
        object = {
          user_id: appUser.user_id,
          name: info?.name || '',
          email: info?.email || '',
          last_action: lastAction,
          last_login: lastLogin,
          exact_online: (appUser.exactonline_access)?1:0,
          twinfield: (appUser.twinfield_access)?1:0,
          multivers: (appUser.integration_multivers)?1:0,
          afas: (appUser.integration_afas)?1:0,
          schedule_access: appUser.schedule_access,
        }
        array.push(object);
      }
      var array = sortByDate(array, 'last_action', 'desc');
      setListArray(array);
    }
  }

  async function handleSortClicked(type){
    if(currentSort.type == type && currentSort.sort == "desc"){
      setCurrentSort({type: false, sort: false})
    }
    else if(currentSort.type == type){
      setCurrentSort({type: type, sort: 'desc'});
    }
    else{
      setCurrentSort({type: type, sort: 'asc'});
    }
  }

  function handleSort(){
    console.log(currentSort);
    if(currentSort.type == 'user_id' || currentSort.type == 'exact_online' || currentSort.type == 'twinfield'	|| currentSort.type == 'multivers'	|| currentSort.type == 'afas'){
      var array = sortByInt(listArray, currentSort.type, currentSort.sort);
    }  
    else if(currentSort.type == 'name' || currentSort.type == 'email'){
      var array = sortByString(listArray, currentSort.type, currentSort.sort);
    } 
    else if(currentSort.type == 'last_login' || currentSort.type == 'last_action'){
      var array = sortByDate(listArray, currentSort.type, currentSort.sort);
    }
    else{
      var array = sortByDate(listArray, 'last_action', 'desc');
      
    }
    setListArray(array);
  }

  function sortByInt(arr, type, order = 'asc') {
    return [...arr].sort((a, b) => {
      const aVal = Number(a[type]) || 0;
      const bVal = Number(b[type]) || 0;

      return order === 'asc' ? aVal - bVal : bVal - aVal;
    });
  }

  function sortByString(arr, type, order = 'asc') {
    return [...arr].sort((a, b) => {
      const aVal = (a[type] ?? '').toString();
      const bVal = (b[type] ?? '').toString();

      return order === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    });
  }
  
  function sortByDate(arr, key, order = 'asc'){
    return [...arr].sort((a, b) => {
      const dateA = a[key] instanceof Date ? a[key] : new Date(a[key]);
      const dateB = b[key] instanceof Date ? b[key] : new Date(b[key]);

      const timeA = isNaN(dateA) ? 0 : dateA.getTime();
      const timeB = isNaN(dateB) ? 0 : dateB.getTime();

      return order === 'asc'
        ? timeA - timeB
        : timeB - timeA;
    });
  }

  async function handleBackClicked(){
    window.location.href = '/app'
  }

  return (
    <div className="user-overview-page">  
      <div className="back-btn-container">
        <FontAwesomeIcon className="btn-back hover" onClick={handleBackClicked} icon={faArrowCircleLeft}/>
      </div>
      <div class="user-overview-title">
        <h2>User overview</h2>
      </div>
      <div>
        <table class="user-overview-table">
          <tr class="table-header">
            <td onClick={()=>handleSortClicked('user_id')}>User id  {(currentSort.type == 'user_id')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('name')}>Name {(currentSort.type == 'name')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('email')}>Email{(currentSort.type == 'email')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('last_action')}>Last Action{(currentSort.type == 'last_action')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('last_login')}>Last login{(currentSort.type == 'last_login')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('exact_online')}>Exact Online{(currentSort.type == 'exact_online')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('twinfield')}>Twinfield{(currentSort.type == 'twinfield')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('multivers')}>Multivers{(currentSort.type == 'multivers')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
            <td onClick={()=>handleSortClicked('afas')}>Afas{(currentSort.type == 'afas')?(<FontAwesomeIcon className="sort-icon" icon={(currentSort.sort == "asc")?faSortUp:faSortDown}/>):null}</td>
          </tr>
          {listArray.length > 0 && listArray.map((row, index) => (
          <tr key={index} value={index}>
            <td>{row.user_id}</td>
            <td>{row.name}</td>
            <td>{row.email}</td>
            <td>{row.last_action.toLocaleString()}</td>
            <td>{row.last_login.toLocaleString()}</td>
            <td>{row.exact_online}</td>
            <td>{row.twinfield}</td>
            <td>{row.multivers}</td>
            <td>{row.afas}</td>
          </tr>
          ))}
        </table>
      </div>
    </div>
  );
}

export default UserOverviewComponent;
